module.exports = __webpack_public_path__ + "img/H-B-1-unload-standup-shadow.c9767645.png";